import buildInfantPassengerFromFormValues from './buildInfantPassengerFromFormValues'
import formatPassengerFormValues from './formatPassengerFormValues'

export const fields = [
  'booking-id',
  'date-of-birth',
  'first-name',
  'gender',
  'last-name',
  'luggage',
  'ssrs',
  'travel-class'
]

export default (passengerId: string, formValues: any) => {
  const passengerValues = fields.reduce(
    (allFieldValues: any, field: string) => ({
      ...allFieldValues,
      [field]: formValues[`${passengerId}-${field}`],
    }),
    {
      infant: buildInfantPassengerFromFormValues(passengerId, formValues),
    }
  )

  /**
   * Currently we always have the gender value (which defaults to 'Male') and
   * the travel-class value (which depends on the class of seats bought during quoting).
   * Due to this we'll have to check if we have more than these values
   * to see if the user filled in the fields.
   */
  const hasValues =
    Object.values(passengerValues).filter((value: any) => value).length > 2

  return hasValues
    ? formatPassengerFormValues({
        id: passengerId,
        ...passengerValues,
      })
    : undefined
}
